import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

// Commons
import Login from '../views/Login.vue'
import RecuperarSenha from "../views/RecuperarSenha";
import Ajuda from '../views/ajuda/Ajuda.vue'
import Documentacao from '../views/ajuda/Documentacao.vue'
import Configs from '../views/configs/Configs.vue'
import Block from '../views/Block.vue'
import Version from '../views/Version.vue'
import Ambiente from '../views/Ambiente.vue'
import P404 from '../views/P404.vue'

// Gestor
import Pedidos from '../views/gestor/Pedidos.vue'
import Cardapio from '../views/gestor/Cardapio.vue'
import Portal from '../views/gestor/Portal.vue'

// Comanda
import HomePdv from '@/views/comanda/HomePdv'
import Relatorio from '@/views/comanda/relatorio/AdminRelatorios'
import Comissoes from '@/views/comanda/relatorio/Comissoes'
import PDV from '@/views/comanda/pdv/PDV'
import Caixas from '@/views/comanda/caixa/AdminCaixas'
import Terminal from '../views/terminal/Terminal.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/recuperar',
    name: 'RecuperarSenha',
    component: RecuperarSenha
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: Pedidos
  },
  {
    path: '/config',
    name: 'Config',
    component: Configs
  },
  {
    path: '/cardapio',
    name: 'Cardapio',
    component: Cardapio
  },
  {
    path: '/portal',
    name: 'Portal',
    component: Portal
  },
  {
    path: '/ajuda',
    name: 'Ajuda',
    component: Ajuda
  },
  {
    path: '/block',
    name: 'Block',
    component: Block
  },
  {
    path: '/versao',
    name: 'Version',
    component: Version
  },
  {
    path: '/ambiente',
    name: 'Ambiente',
    component: Ambiente
  },
  {
    path: '/ajuda/documentacao',
    name: 'Documentacao',
    component: Documentacao
  },
  {
    path: '/terminal',
    name: 'Terminal',
    component: Terminal
  },
  {
    path: '/home',
    name: 'HomePdv',
    component: HomePdv
  },
  {
    path: '/home/relatorios',
    name: 'Relatorios',
    component: Relatorio
  },
  {
    path: '/home/caixas',
    name: 'Caixas',
    component: Caixas
  },
  {
    path: '/home/comissao',
    name: 'Comissoes',
    component: Comissoes
  },
  {
    path: '/pdv',
    name: 'NovoPDV',
    component: PDV
  },
  {
    path: '/pdv/mesa/:id',
    name: 'NovoPDVMesa',
    component: PDV
  },
  {
    path: '/pdv/delivery',
    name: 'NovoPDVDelivery',
    component: PDV
  },
  {
    path: '/pdv/balcao',
    name: 'NovoPDVBalcao',
    component: PDV
  },
  {
    path: '/pdv/comanda/:id',
    name: 'NovoPDVComanda',
    component: PDV
  },
  {
    path: '/pdv/venda-rapida',
    name: 'NovoPDVVendaRapida',
    component: PDV
  },
  {
    path: '/pdv/:id',
    name: 'NovoPDVID',
    component: PDV
  },
  {
    path: '/*',
    name: 'P404',
    component: P404
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (store.state.is_block && !['Block', 'Portal'].includes(to.name)) {
    if (to.name === 'Portal') {
      return next();
    }

    return next({ name: 'Portal' });
  }

  next();
});

export default router
